import { cn } from "@/lib/utils";

const MAP = {
  Verified: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Unverified: "bg-amber-50 text-amber-700 border-amber-200",
  Stale: "bg-rose-50 text-rose-700 border-rose-200",
};

export function ConfidenceBadge({ label, score, className }) {
  const c = MAP[label] || "bg-slate-50 text-slate-600 border-slate-200";
  return (
    <span data-testid="confidence-badge" className={cn("inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold", c, className)}>
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {label}{score != null && <span className="font-mono opacity-70">{score}</span>}
    </span>
  );
}

export function SourceChip({ name, type }) {
  return (
    <span data-testid="source-chip" className="inline-flex items-center gap-1 rounded-full border border-slate-200 bg-slate-100 px-2 py-0.5 text-[11px] font-medium text-slate-600">
      {type && <span className="uppercase tracking-wide text-slate-400">{type}</span>}
      {name}
    </span>
  );
}

export function StatusPill({ status }) {
  const s = (status || "unknown").toLowerCase();
  const map = {
    available: "bg-emerald-100 text-emerald-700",
    charging: "bg-sky-100 text-sky-700",
    outoforder: "bg-rose-100 text-rose-700",
    unknown: "bg-slate-100 text-slate-500",
  };
  return <span className={cn("rounded px-2 py-0.5 text-[11px] font-medium capitalize", map[s] || map.unknown)}>{status || "unknown"}</span>;
}
